import { toast as sonnerToast } from 'sonner';

type ToastOptions = Parameters<typeof sonnerToast>[1];

const baseStyle: NonNullable<ToastOptions>['style'] = {
  background: 'rgb(19, 19, 22)',
  color: 'rgb(250, 250, 250)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
};

export const toast = {
  success: (message: string, opts?: ToastOptions) =>
    sonnerToast.success(message, {
      style: { ...baseStyle, borderColor: 'rgba(52, 211, 153, 0.4)' },
      ...opts,
    }),
  error: (message: string, opts?: ToastOptions) =>
    sonnerToast.error(message, {
      style: { ...baseStyle, borderColor: 'rgba(248, 113, 113, 0.4)' },
      ...opts,
    }),
  info: (message: string, opts?: ToastOptions) =>
    sonnerToast(message, { style: baseStyle, ...opts }),
  warning: (message: string, opts?: ToastOptions) =>
    sonnerToast.warning(message, {
      style: { ...baseStyle, borderColor: 'rgba(251, 191, 36, 0.4)' },
      ...opts,
    }),
  loading: (message: string, opts?: ToastOptions) =>
    sonnerToast.loading(message, { style: baseStyle, ...opts }),
  promise: sonnerToast.promise,
  dismiss: sonnerToast.dismiss,
};

export { Toaster } from 'sonner';